import {createAsyncThunk} from "@reduxjs/toolkit";
import axios from "axios";
import {fetchProfileData} from "../../../../entities/Profile/model/fetchProfileDate/fetchProfileDate";
import {registerActions} from "../../slice/registerSlice";

export interface IRegisterByUserProps {
    firstName: string;
    lastName: string;
    email: string;
    phone: string;
    password: string;
    retypePassword: string;
    privacyAccept:boolean;
    promoCode: string;
}

export const registerByUser = createAsyncThunk<void, IRegisterByUserProps>(
    'register/registerByUser',
    async (registerData, thunkAPI) => {
        try {
            const response = await axios.post('/api/registration', registerData);
            if (!response.data) {
                throw new Error("Response data is empty.");
            }
            thunkAPI.dispatch(registerActions.setRegisterData(response.data));
            thunkAPI.dispatch(fetchProfileData());
        } catch (e) {
            console.error("Registration error:", e);
            throw e;
        }
    }
);
